var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZoom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 26,
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#000",
    fillOpacity: 0.2,
    height: 26,
    rx: 6,
    width: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M26 0H6a6 6 0 00-6 6v14a6 6 0 006 6h20a6 6 0 006-6V6a6 6 0 00-6-6zM2 6a4 4 0 014-4h20a4 4 0 014 4v14a4 4 0 01-4 4H6a4 4 0 01-4-4V6zm4 1a1 1 0 011-1h6a1 1 0 110 2H8v2a1 1 0 11-2 0V7zm12 0a1 1 0 011-1h6a1 1 0 011 1v3a1 1 0 11-2 0V8h-5a1 1 0 01-1-1zm7 8a1 1 0 011 1v3a1 1 0 01-.987 1H19a1 1 0 110-2h5v-2a1 1 0 011-1zM7 15a1 1 0 011 1v2h5a1 1 0 110 2H7a1 1 0 01-1-1v-3a1 1 0 011-1z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.5d63e8510fcd3534e109e6c0e1581006.svg";
export { ForwardRef as ReactComponent };